import { render, staticRenderFns } from "./Referralq.vue?vue&type=template&id=406943fc&"
import script from "./Referralq.vue?vue&type=script&lang=ts&"
export * from "./Referralq.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports